import { useLoad } from "@redotech/react-util/load";
import { RedoClient } from "@redotech/redo-api-client";
import {
  getAutocheck,
  ShopifyExtensionClient,
} from "@redotech/redo-shopify-extension/client/shopify-extension-client";
import {
  ModalContent,
  ModalContentV2,
  V2ImageWrapper,
} from "@redotech/redo-shopify-extension/modal";
import { InfoModalVersion } from "@redotech/redo-storefront-common/info-modal-version";
import { memo } from "react";
import { REDO_API_URL } from "./config";
import * as infoCss from "./info.module.css";

const widgetId = new URLSearchParams(location.search).get("widgetId");
if (!widgetId) {
  throw new Error("Missing widgetId");
}

export const Info = memo(function Info() {
  const redoClient = new RedoClient(REDO_API_URL);
  const widgetClient = new ShopifyExtensionClient(redoClient, widgetId);

  const autocheck = useLoad(
    (signal) => getAutocheck(widgetClient, { signal, customerId: null }),
    [],
  );

  if (!autocheck.value) {
    return null;
  }

  const {
    coverage,
    coverageEnabled,
    finalSaleReturns,
    infoModal,
    packageProtection,
    returnPolicyUrl,
  } = autocheck.value;

  if (infoModal?.version === InfoModalVersion.V2) {
    return (
      <div className={infoCss.infoV2}>
        <V2ImageWrapper
          customCss={infoModal.customCss}
          isPreview
          sideImage={infoModal.sideImage}
        >
          <ModalContentV2
            finalSaleReturnsCoverageEnabled={
              finalSaleReturns?.coverageEnabled ?? false
            }
            modalCustomizationsV2={infoModal}
            packageProtectionEnabled={packageProtection?.coverageEnabled}
            packageProtectionPlusEnabled={
              packageProtection?.packageProtectionPlusEnabled
            }
            returnPolicyUrl={returnPolicyUrl}
            returnsCoverage={coverage}
            returnsCoverageEnabled={coverageEnabled}
          />
        </V2ImageWrapper>
      </div>
    );
  }

  return (
    <div className={infoCss.info}>
      <ModalContent
        modalLogo={autocheck.value.modalLogo}
        modalTextAdjustments={autocheck.value.modalTextAdjustments}
        packageProtectionPlusEnabled={
          packageProtection?.packageProtectionPlusEnabled
        }
        returnPolicyUrl={returnPolicyUrl}
      />
    </div>
  );
});
